import { render } from "./Label.vue?vue&type=template&id=bc75442c"
import script from "./Label.vue?vue&type=script&lang=js"
export * from "./Label.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__